import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/App.css';
import ReactGA from "react-ga4";

// Initialize Google Analytics
const TRACKING_ID = "G-2S0WM6YE3G"; // Replace with your Google Analytics tracking ID
ReactGA.initialize(TRACKING_ID);

// Track page views
ReactGA.send({ hitType: "pageview", page: "index.js", title: "index.js" });

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);